import React from "react";

const CPP_Projects = () => {
  return (
    <div>
      <h1>CPP_Projects Component</h1>
      <p>Content for CPP_Projects goes here...</p>
    </div>
  );
};

export default CPP_Projects;
